export { NgrxRouterModule } from './lib/router.module';
export * from './lib/+state/router.actions';